module.exports = require("braintree-web-drop-in");